import React from "react";
import { IMAGE_BASE_URL } from "../data/baseURL";

const Kpi = ({ where_work_kps }) => {
  return (
    <div className="container-fluid pt-7 pb-7" id="kpis">
      <div className="ms-47 me-47">
        <div className="row">
          <div className="col-lg-2">
            <h1 className="fs-28 text-capitalize">KPIs</h1>
          </div>
          <div className="col-lg-10 fs-18">
            <div className="row">
              {where_work_kps?.map((data, index) => (
                <div className="col-md-3 mb-5" key={index}>
                  <div className="bg-white rounded-lg mb-5 review-shadow position-relative transform-up h-100">
                    <div className="d-flex justify-content-center">
                      <img
                        src={`${IMAGE_BASE_URL}/${data?.image}`}
                        alt="user"
                        className="img-fluid rounded"
                      />
                    </div>
                    <div className="text-center mt-3 p-2">
                      <h3 className="fs-18 fw-bold text-secondary">
                        {data?.sites} <span className="text-orange-ryb">+</span>
                      </h3>
                      <div className="fs-14">
                        <p className="text-secondary mb-0">Sites</p>
                        <p className="text-orange-ryb mb-0">
                          {data?.tenancy_ratio}
                        </p>
                        <p className="text-secondary">{data?.tenants}</p>
                      </div>
                    </div>
                    <div className="review-card-border"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Kpi;
